import { showMessages } from '@intercom/messenger-js-sdk';
import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { WarningCircleIcon } from '@synoptic/ui-kit/icons/react/warning-circle.tsx';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { clsx } from 'clsx';
import { FC } from 'react';
import {
  createStreamFormActions,
  formInfoBlock,
  formInfoDescription,
  formInfoTitle,
  streamFormActions,
} from '@/components/streams/stream-form/stream-form.css.ts';

export const ReCreateStripeAccount: FC<{
  onCreate: () => void;
  loading: boolean;
}> = ({ onCreate, loading }) => {
  const isTablet = useIsTablet();

  return (
    <div>
      <div className={formInfoBlock}>
        <h3 className={formInfoTitle}>
          <WarningCircleIcon width={20} height={20} />
          We were unable to create a seller account link for you
        </h3>
        <p className={formInfoDescription}>
          Please, try again or contact support for help.
        </p>
      </div>
      <div className={clsx(streamFormActions, createStreamFormActions)}>
        <Button
          size={isTablet ? 'large' : 'medium'}
          variant={'secondary'}
          onClick={() => {
            showMessages();
          }}
        >
          Contact support
        </Button>
        <Button
          loading={loading}
          onClick={onCreate}
          size={isTablet ? 'large' : 'medium'}
        >
          Try again
        </Button>
      </div>
    </div>
  );
};
